import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { Toaster } from '@/components/ui/toaster'
import { Toaster as Sonner } from '@/components/ui/sonner'
import { TooltipProvider } from '@/components/ui/tooltip'
import Index from './pages/Index'
import NotFound from './pages/NotFound'
import SessionHistoryPage from './pages/SessionHistory'
import LoginPage from './pages/Login'
import ProfilePage from './pages/Profile'
import OrganizationsPage from './pages/Organizations'
import OrganizationDetailsPage from './pages/OrganizationDetails'
import AgentsPage from './pages/Agents'
import { ProtectedRoute } from './components/ProtectedRoute'
import useAuthStore from './stores/useAuthStore'
import { useEffect } from 'react'
import AuthCallbackPage from './pages/AuthCallback'
import ChatPage from './pages/ChatPage'
import useChatStore from './stores/useChatStore'

const AppRoutes = () => {
  const { isAuthenticated, fetchUser, token } = useAuthStore()

  useEffect(() => {
    if (isAuthenticated) {
      fetchUser()
    }
  }, [isAuthenticated, fetchUser, token])

  useEffect(() => {
    const unsubscribe = useChatStore.persist.onFinishHydration((state) => {
      if (state.messages.length > 0 && state.sessionId) {
        useChatStore.getState().setRecoveryIndicator('hydrated')
      }
    })
    return unsubscribe
  }, [])

  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/auth/google" element={<AuthCallbackPage />} />
      <Route element={<ProtectedRoute />}>
        <Route path="/" element={<Index />} />
        <Route path="/session/:sessionId" element={<ChatPage />} />
        <Route path="/history" element={<SessionHistoryPage />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/organizations" element={<OrganizationsPage />} />
        <Route
          path="/organizations/:id"
          element={<OrganizationDetailsPage />}
        />
        <Route path="/agents" element={<AgentsPage />} />
      </Route>
      <Route path="*" element={<NotFound />} />
    </Routes>
  )
}

const App = () => (
  <BrowserRouter future={{ v7_startTransition: true, v7_splat_routes: true }}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <AppRoutes />
    </TooltipProvider>
  </BrowserRouter>
)

export default App
